import { createContext, useEffect, useState, useRef } from "react";
import {
  fetchCategories,
  fetchCurrentUser,
  fetchStatusChoices,
  fetchUserCategories,
  fetchUsers,
  fetchWorkTypes,
} from "./api";

// Create the context
export const AppContext = createContext();

// Create a provider component
export const AppProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [allUsers, setAllUsers] = useState([]);
  const [userCategories, setUserCategories] = useState([]);
  const [allCategories, setAllCategories] = useState([]);
  const [tasks, setTasks] = useState([]);
  const [tasksQueryData, setTasksQueryData] = useState([]);
  const [workTypes, setWorkTypes] = useState([]);
  const [statusChoices, setStatusChoices] = useState([]);
  const [loading, setLoading] = useState(true);

  const setContext = async () => {
    setLoading(true);
    // const storedUser = localStorage.getItem("user");
    try {
      // Fetch the user from the API if not in localStorage
      const fetchedUser = await fetchCurrentUser();
      setUser(fetchedUser);
      localStorage.setItem("user", JSON.stringify(fetchedUser));
    } catch (error) {
      // console.error("Error fetching user:", error);
    }
    try {
      const fetchedUsers = await fetchUsers();
      //sort by last name and then first name
      fetchedUsers.sort((a, b) => {
        if (a.last_name === b.last_name) {
          return a.first_name.localeCompare(b.first_name);
        }
        return a.last_name.localeCompare(b.last_name);
      });
      setAllUsers(fetchedUsers);
    } catch (error) {
      // console.error("Error fetching users:", error);
    }
    try {
      const fetchedUserCategories = await fetchUserCategories();
      setUserCategories(fetchedUserCategories);
    } catch (error) {
      // console.error("Error fetching user categories:", error);
    }
    try {
      const fetchedCategories = await fetchCategories();
      setAllCategories(fetchedCategories);
    } catch (error) {
      // console.error("Error fetching categories:", error);
    }
    try {
      const fetchedWorkTypes = await fetchWorkTypes();
      setWorkTypes(fetchedWorkTypes);
    } catch (error) {
      // console.error("Error fetching work types:", error);
    }
    try {
      const fetchedStatusChoices = await fetchStatusChoices();
      setStatusChoices(fetchedStatusChoices);
    } catch (error) {
      // console.error("Error fetching status choices:", error);
    }
    setLoading(false);
  };

  useEffect(() => {
    setContext();
  }, []);

  if (loading) {
    return <div>Loading...</div>;
  }

  const statusDict = {
    Open: "Aperta",
    Closed: "Chiusa",
  };

  return (
    <AppContext.Provider
      value={{
        setContext,
        user,
        allUsers,
        allCategories,
        userCategories,
        tasks,
        setTasks,
        tasksQueryData,
        setTasksQueryData,
        workTypes,
        statusChoices,
        statusDict,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};
